import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "canvas",
  style: {"border":"2px solid black"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_canvas = _resolveDirective("canvas")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createTextVNode(" Draw below: ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("canvas", _hoisted_1, null, 512), [
      [_directive_canvas]
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
    }, "Clear"),
    (!_ctx.modelLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading"))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, "Guess is " + _toDisplayString(_ctx.guess) + ", confidence is " + _toDisplayString(_ctx.confidence), 1)),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("a", { href: "https://github.com/waridrox/digit-recognition" }, "Source on GitHub", -1))
  ]))
}